export default "__VITE_ASSET__BEG51bAw__"